"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistoryTranscriptCommonModelInputRole = void 0;
exports.ConversationHistoryTranscriptCommonModelInputRole = {
    User: "user",
    Agent: "agent",
};
